export default __webpack_public_path__ + "static/media/YelekBeko.f0203bf0.jpg";